"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRatingItem = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledRatingItem = _styledComponents.default.li.withConfig({
  displayName: "RatingItemstyles__StyledRatingItem",
  componentId: "sc-93h1u0-0"
})(["display:inline-block;margin:0 ", ";.c-rating-item-accepts-hover{&:hover{transform:scale3d(1.1,1.1,1.1);transition:all 100ms;}}"], function (props) {
  return (0, _helperFunctions.joinDimensions)('/', props.theme.standardPadding, 2);
});

exports.StyledRatingItem = StyledRatingItem;